module.exports = {
  appName: '製造執行管理系統',
  message: {
    title: '系統提示',
    error_factory_code_not_input: '請輸入工廠編碼',
    error_employee_code_not_input: '請輸入員工編碼',
    error_custom_code_not_input: '請輸入客戶編碼',
    error_verify_code_not_input: '請填寫驗證碼',
    error_login_password_not_input: '請輸入登入密碼',
    error_device_code_not_input: '請輸入設備編碼',
    error_info: '錯誤資訊',
    error_ajax: '數據請求出錯，請重繪後重試！',
    error_not_login: '請登陸後重試!',
    error_permission_validate: '你沒有許可權執行當前操作!',
    error_can_empty: '當前項不能為空！',
    error_opera_retry: '操作失敗，請重試!',
    timeout: '連接超時，請重試！',
    error_sysdate_can_not_execute_current_opera: '系統數據，不能執行該操作！',
    error_can_not_delete_because_used: '當前數據被使用中，不能删除！',
    error_code_same_pleas_change: '編碼重複，請確認！',
    has_children_can_not_delete: '存在子項，不能删除！',
    please_input_required_items: '請輸入必填項!',
    please_select_row_to_opera: '請選擇要操作的數據',
    please_check_row_to_opera: '請勾選要操作的數據',
    can_not_delete_system_data: '系統數據，不能删除',
    error_404: '您訪問的頁面不存在',
    error_403: '您沒有許可權訪問當前頁面',
    error_go_back: '返回上一頁',
    error_go_login: '返回登入',
    Employee_Code_does_not_exist: '員工編碼【%1】不存在',
    Device_code_does_not_exist: '設備編碼【%1】不存在',
    Craft_code_does_not_exist: '工艺编码【%1】不存在',
    please_select_part_to_opera: '請選擇要操作的零件',
    please_select_process_to_opera: '請選擇要操作的工序',
    old_password_error: '原始密碼錯誤',
    confirm_delete_data: '確認要删除選中數據嗎？',
    error_param_validate: '參數校驗失敗，請確認是否非法訪問！'
  },
  login: {
    login: '登入',
    remember: '記住密碼',
    verify_code: '驗證碼'
  },
  nav: {
    produce_order: '生產工單',
    project_manage: '專案管理',
    process_manage: '工序管理',
    progress_query: '進度查詢',
    report: '現場報工',
    quality_manage: '品質管制',
    quality_determine: "質量判定",
    quality_penalty: "質量處罰",
    quality_recall: "質量召回",
    system_setting: '系統設定',
    modify_password: '修改密碼',
    personal_center: '個人中心',
    exit_system: '退出系統',
    plan: '日計畫管理',
    forms: '報表',
    basic_data: {
      title: '基礎資料',
      factory_setting: '廠區設定',
      department_manage: '部門管理',
      role_manage: '角色管理',
      employee_manage: '員工管理',
      device_manage: '設備管理',
      operation_manage: '工藝管理',
      production_line_manage: '產線管理',
      cost_type_manage: '費用類型',
      shelf_manage: '貨架管理',
      work_group_manage: '工作組管理',
      software_download: '軟體下載'
    },
    classify_setting: {
      title: '分類設定',
      product_type: '產品類型',
      order_type: '訂單類型',
      part_classify: '零件分類',
      error_classify: '錯誤分類',
      project_classify: '項目分類'
    },
    job_deployment: '工作部署',
    standard_process_library: '標準工藝庫',
    custom_column: '自定義列',
    log_manage: '日誌管理',
    approval_process: '審批流程',
    class_table_setting: '班錶設定',
    holiday_setting: '假日設定',
    offline_file_setting: '線下檔案設定',
    standard_procedure_setting: '指導書設定',
    project_master_plan: '主計畫',
    project_master_plan_template_setting: '主計畫範本設定',
    customer_form: '自定義表單'
  },
  common: {
    opera: '操作',
    open: '打開',
    upload: '上傳',
    file: '檔案',
    setting: '設定',
    factoryCode: '工廠編碼',
    employeeCode: '員工編碼',
    LoginPassword: '登入密碼',
    add_user: '添加人',
    add_time: '添加時間',
    update_user: '更新人',
    update_time: '更新時間',
    add: '添加',
    save: '保存',
    saveAndAdd: '保存並繼續添加',
    reset: '重新填寫',
    cancel: '取消',
    delete: '删除',
    edit: '編輯',
    query: '査詢',
    img_is_not_upload: '影像未上傳',
    confirm: '確認',
    filter: '篩選',
    please_input_filter_content: '請輸入篩選內容',
    default_value_setting: '預設值設定',
    name: '名稱',
    remark: '備註',
    display: '顯示',
    hide: '隱藏',
    move: '移動',
    copy: '複製',
    see: '查看',
    split: '分割',
    more: '更多',
    approved: '已審批',
    approval_status: '審批狀態',
    approval_sponsor: '審批發起人',
    approver: '審批人',
    approval_approval: '審批通過',
    approval_return: '審批退回',
    ongoing: '進行中',
    opera_type: '操作類型',
    code: '編碼',
    capacity: '產能',
    select_department: '選擇部門',
    select_resources: '選擇資源',
    craft: '工藝',
    production_line: '產線',
    status: '狀態',
    today: '今天',
    import_start_row: '起始行',
    select_craft: '選擇工藝',
    amount: '金額',
    paste: '粘貼',
    close_copy_model: '退出複製模式',
    reset_cache: '重置瀏覽器緩存'
  },
  password: {
    original_password: '原始密碼',
    new_password: '新密碼',
    confirm_password: '確認密碼',
    error_please_input_original_password: '請輸入原始密碼',
    error_please_input_new_password: '請輸入新密碼',
    error_please_input_confirm_password: '請輸入確認密碼',
    error_please_input_password_not_same: '兩次輸入的密碼不一致',
    default_password_tip: '員工默認密碼: 123456',
    reset_password: '重置密碼',
    password_is_reset: '密碼重置成功，新的密碼為: 123456'
  },
  status: {
    scrap: '報廢',
    normal: '正常',
    repair: '維修'
  },
  basic_data: {
    nav_width: '160px',
    role_manage: {
      role_name: '角色名稱',
      used_count: '使用次數',
      role_type: '角色類型',
      role_permissions: '角色許可權',
      system_role: '系統角色',
      custom_role: '自定義角色'
    },
    department_manage: {
      Superior_department: '上級部門',
      Department_code: '部門編碼',
      Department_name: '部門名稱',
      work_condition: '工作狀態',
      work_status_on: '啟用',
      work_status_off: '停用',
      add_sub_department: '添加子部門',
      add_brother_department: '添加同級部門'
    },
    employee_manage: {
      status_on_the_job: '在職',
      status_vacation: '休假',
      status_quit: '離職',
      employee_code: '員工編碼',
      employee_name: '員工名稱',
      employee_role: '員工角色',
      subordinate_department: '所屬部門',
      department_establishment_number: '部門編制號',
      working_condition: '工作狀態',
      normal_production_capacity: '正常產能',
      budgetary_capacity: '預算產能',
      id_number: '身份證號',
      departmental_role: '部門角色',
      department_staff: '部門員工',
      department_head: '部門首長',
      phone_number: '電話號碼',
      email: '郵箱',
      user_code_same: '員工編碼重複!'
    },
    device_manage: {
      working_condition: '工作狀態',
      device_code: '設備編碼',
      device_name: '設備名稱',
      equipment_brand: '設備品牌',
      producing_area: '設備產地',
      Normal_capacity: '正常產能',
      Maximum_capacity: '最大產能',
      Budget_capacity: '預算產能'
    },
    cost_type_manage: {
      cost_type: '費用類型',
      cost_type_code: '費用類型編碼',
      cost_type_name: '費用類型名稱',
      parent_cost_type_code: "父費用類型編碼",
      parent_cost_type_name: "父費用類型名稱",
      edit_parent_cost_type: '編輯父費用類型',
      edit_sub_cost_type: '編輯子費用類型'
    },
    operation_manage: {
      manual_operation: '手動工藝',
      automatic_process: '自動工藝',
      subsidiary_process: '附屬工藝',
      outside_the_plan: '計畫外',
      procurement_process: '採購工藝',
      outside_process: '外協工藝',
      internal_process: '內制工藝',
      project_process: '项目工艺',
      process_coding: '工藝編碼',
      process_name: '工藝名稱',
      process_attributes: '工藝内容',
      process_type: '工藝類型',
      conversion_process: '轉換工藝',
      clamping_procedure: '鉗制工藝',
      report_way: '報工管道',
      scheduling_attributes: '排程内容',
      cost_type: '費用類型',
      default_preparation_time: '準備工時',
      default_device_hours: '設備工時',
      default_manpower_hours: '人力工時',
      according_to_production_parameters: '按生產參數',
      ordinary: '普通',
      according_to_materiel_out_of_stock_code: '按物料出庫條碼',
      allowable_excess_capacity: '允許超產能',
      prohibition_excess_capacity: '禁止超產能',
      default_part_size: '默認零件大小',
      large_part_size: '大型零件',
      medium_part_size: '中型零件',
      small_part_size: '小型零件',
      default_transfer_time: '轉移時間',
      default_preset_days: '預置天數',
      general_parts: '一般零件',
      core_parts: '核心零件',
      material_retrieval_code: '物料出庫條碼',
      bar_code_content: '條碼內容'
    },
    production_line_manage: {
      production_line_code: '產線編碼',
      production_line_name: '產線名稱'
    },
    shelf_manage: {
      shelf_code: '貨架編碼',
      shelf_name: '貨架名稱',
      shelf_remark: '貨架備註'
    },
    custom_manage: {
      title: '客戶管理',
      custom_code: '客戶編碼',
      custom_name: '客戶簡稱',
      custom_full_name: '客戶全稱',
      custom_address: '地址',
      custom_area: '區域',
      custom_tel: '電話',
      custom_fax: '傳真',
      custom_mail: '郵箱',
    }
  },
  job_deployment: {
    operation_group: '工作組',
    administrative_department: '管理部門',
    operation_group_coding: '工作組編碼',
    name_of_operation_group: '工作組名稱',
    normal_production_capacity: '正常產能',
    maximum_capacity: '最大產能',
    association_process: '關聯工藝',
    associated_production_line: '關聯產線',
    associated_resources: '資源',
    resource_type: '資源類型',
    resource_coding: '資源編碼',
    resource_name: '資源名稱',
    staff: '員工',
    equipment: '設備',
    shelves: '貨架',
    work_attributes: '工作内容',
    job_level: '工作等級',
    partTime_productivity: '兼職產能',
    fullTime: '全職',
    partTime_job: '兼職',
    downtime: '停機',
    apprentice: '學徒',
    primary: '初級',
    intermediate: '中級',
    senior: '高級',
    expert: '專家',
    group_resources_delete_intercept: '選中資源中，部分資源已經分配給工藝，不能删除！',
    craft_resources: '工藝資源'
  },
  custom_column: {
    integer: '整數',
    decimal: '小數',
    text: '文字（500字以內）',
    date: '日期',
    column_type: '列類型',
    system_definition_column: '系統定義列',
    upper_shift: '上移列',
    down_shift: '下移列',
    employee_selection: '員工選擇',
    device_selection: '設備選擇',
    show_in_table: '表格中可見',
    hide_in_table: '表格中隱藏',
    img: '圖片',
    column_width: '列寬/ps',
    column_attribute: '列属性'
  },
  produce_order: {
    diagram: '簡圖',
    order_area: '工單區域',
    processing_order: '在制工單',
    completion_order: '完工工單',
    area_name: '區域名稱',
    can_report: '參與報工',
    can_schedule: '參與排產',
    add_sub_area: '添加子區域',
    add_brother_area: '添加同級區域',
    internal_part_only: '僅內制零件',
    internal_and_external_part: '內制和外發零件',
    lock_plan: '鎖定計畫',
    not_locked: '不鎖定',
    production_work_order: '生產工單',
    rate_of_progress: '進度',
    delay_days: '延誤',
    copy_order_plan: '複製生產工單主計畫',
    copy_part_and_process: '複製零件及工序',
    copy_try_count: '複製調試次數',
    target_try_count: '目標調試次數',
    order_attribute: '工單内容',
    plan_attribute: '計畫内容',
    product_attribute: '產品内容',
    customer_attribute: '客戶内容',
    calling_bom: 'BOM調用',
    can_automatic: '自动移动完工'
  },
  produce_part: {
    part_list_title: '零件清單',
    part_select_all: '全選',
    part_un_select: '反選',
    part_attribute_default: '全部',
    part_attribute_part: '零件',
    part_attribute_sub: '附屬零件',
    part_attribute_design: '設計',
    part_attribute_assemble: '裝配',
    part_attribute_debug: '調試',
    produce_part_split: '零件分割',
    part_split_error_message: '手動輸入的數量超過了總數量，請重新輸入!',
    part_code_exist: '【%1】已存在',
    part_delete_tips: '此操作将删除选中的【%1】个数据, 是否继续?',
    part_copy_tips: '此操作将复制选中的【%1】个数据, 是否继续?',
    emergency_order: '緊急插單',
    emergency_order_cancel: '取消插單',
    emergency_order_confirm: '確定要執行緊急插單嗎？',
    emergency_order_icon: '插單'
  },
  produce_part_sub_list: {
    part_sub_list_title: '附屬零件清單',
    part_sub_list_column_orderIndex: '序號',
    part_sub_list_column_orderCode: '工單號',
    part_sub_list_column_orderName: '订单名称',
    part_sub_list_column_subPartCode: '附屬零件號',
    part_sub_list_column_subPartName: '附属零件名称',
    part_sub_list_column_num: '數量',
    part_sub_list_column_tryCount: '調試次數',
    part_sub_list_column_st: 'AP工时(分)',
    part_sub_list_column_readySt: '準備工時',
    part_sub_list_column_humanSt: '人力労働時',
    part_sub_list_column_deviceSt: '設備工時',
    part_sub_list_column_predictSt: '模拟工时',
    part_sub_list_column_totalSt: '總工時',
    part_sub_list_column_file: 'AP工序科技檔案',
    part_sub_list_choose_title: '选择附属零件列表',
    part_sub_list_selected: '选中列表'
  },
  produce_process: {
    process: '工序',
    process_list: '工序清單',
    produce_process_split: '工序分割',
    please_input_required_split_num: '请输入分割数量',
    process_split_num: '分割數量',
    process_split_st: '分割工時',
    part_card: "零件工藝卡",
    process_card: '工序工藝卡',
    same_crafts_card: "相同工藝卡",
    process_achievement: '實績明細',
    process_state_un_start: "未开始",
    process_state_processing: "加工中",
    process_state_completed: "已完工",
    process_state_suspended: "暂停加工",
    process_state_scrapped: "报废",
    process_state_purchase: "特采",
    process_state_received: "接收",
    process_state_part_received: "部分接收",
    process_state_un_completed: "未完工",
    appoint_time_tips: '开始时间不能大于结束时间!'
  },
  process_library: {
    standard_order: '標準訂單 ',
    template_no: "模板編碼",
    template_name: '範本名稱',
    template_attribute: '属性',
    template_attribute_craft: '工艺',
    import_part_process: '导入零件和工序',
    import_part: '导入零件',
    import_process: '导入工序',
    template_not_empty: "模板編碼或模板名稱不能為空!"
  },
  approval_process: {
    Approval_type: '審批類型',
    Associated_data: '關聯數據',
    Approval_add: '審批添加',
    Approval_modification: '審批修改',
    Approval_deletion: '審批删除',
    Process_name: '流程名稱',
    Process_notes: '流程備註',
    Approval_process: '審批流程',
    Reporting_time: '上報時間',
    Approval_intercept: '審批攔截',
    Departmental_approval: '部門審批',
    superior_departments_approval: '上級部門審批',
    custom_approval: '自定義流程',
    All_approval: '審批全部',
    All_data_will_be_approved: '將審批全部數據',
    Approval_by_order_type: '按工單類型審批',
    Data_specifying_only_the_type_of_work_order: '只指定工單類型的數據',
    Approval_by_product_type: '按產品類型審批',
    Data_that_specifies_only_product_types: '只指定產品類型的數據',
    please_select_approval_process: '請選擇審批流程'
  },
  approval_process_setting: {
    add_root_node: '添加審批節點',
    auditor: '稽核人'
  },
  report: {
    report_type: '報工類型',
    report_receive: '接收',
    report_start: '開始',
    report_unfinished: '未完工',
    report_finished: '完工',
    report_outside: '計畫外',
    report_bar_code: '報工條碼',
    report_single_person: '單人報工',
    report_many_people: '多人報工',
    report_part_schedule: '零件進度',
    report_record: '報工記錄',
    report_source: '報工來源',
    view_work_reporting_barcode: '查看報工條碼',
    appoint_resource_code: '指定資源編碼',
    appoint_resource_name: '指定資源名稱',
    previous_process: '上道工序',
    next_process: '下道工序',
    operation_user: '實際操作者',
    scan_barcode: '是否掃描條碼',
    code_type: '條碼類型',
    qr_code: '條碼',
    packet_number: '包數',
    finished_quantity_cannot_be_less_than: '完工數量不能小於0.01',
    the_start_quantity_cannot_be_greater_than_the_machinable_quantity: '開始數量不能大於可加工數',
    batch_requisition_can_only_be_executed_under_the_same_processing_condition: '相同加工狀態才可以執行批量報工',
    same_process_can_be_applied_for_batch_work: '相同工藝才可以執行批量報工',
    barcode_already_exists: '條碼已經存在',
    barcode_format_is_wrong: '條碼格式不正確',
    are_you_sure_you_want_to_perform_operations_on_processes: '要對[$1]道工序進行[$2]操作，確定要執行嗎？',
    selected_process_exists_already_started_process: '選中工序存在已開始工序！',
    tips_for_multiple_workers: '當前任務由多人完成，您需報【未完工】，並輸入個人實際完成數量或完成比率】',
    There_is_an_unacceptable_process_in_the_selected_process: '選中工序中存在不能接收的工序！',
    No_finished_quantity_in_the_previous_process: '選中工序中存在上道工序沒有完工數量，不能接收！',
    There_is_no_starting_process_in_the_selected_process: '選中工序中存在未開始工序！',
    batch_operation_not_supported_finish: '當前報工不支持批量操作，請單獨選擇報工，如為批量開始的工序，則自動批量執行！',
    confirm_batch_report_finish: '當前工序為批量開始，是否同時批量操作的其他工序？',
    Batch_reporting: '批量報工',
    Unpacking: '拆包報工',
    Batch_start: '批量開始',
    Batch_completion: '批量完工',
    Unfinished_batch: '批量未完工',
    Batch_reception: '批量接收',
    report_info_setting: '報工資訊設定',
    send_remark: '交接說明',
    receive_num: '接收數量',
    send_user: '發送人',
    message_please_select_resources_for_insert: '請選擇$1',
    mach_num: '加工數量',
    finish_num: '完成數量',
    mach_user: '加工人',
    mach_device: '加工設備',
    completion_rate: '工時完成率',
    confirm_batch_finish: '將要對選中的工序，及其批量開始的工序進行完工操作，確定執行嗎？',
    confirm_batch_un_finish: '將要對選中的工序，及其批量開始的工序進行未完工操作，批量未完工完成數量及完成率皆為0，確定執行嗎？',
    process_is_not_existence: '工序不存在！',
    process_can_not_report: '該工序不能報工！',
    process_is_existence_to_select: '工序存在，以選中該工序',
    process_can_mach_num_is_zero: '選中工序可加工數量為0！',
    previous_process_is_not_finish: '上道工序未完工，當前工序不能開始！',
    has_previous_process_not_finish_process: '選中工序中，存在上道工序未完工的工序，不能開始！',
    total_st: '總工時',
    finish_st: '完成工時',
    process_can_not_add_report_detail: '當前工序沒有可報工數量，不能添加！',
    report_by_param_can_not_batch_report: '按生產參數報工的工序，不能批量報工！',
    report_by_material_out_barcode: '按物料出庫條碼報工的工序，不能執行批量報工！',
    please_input_material_out_barcode: '請輸入物料出庫條碼!',
    finish_ratio: '完成率',
    current_finish_ratio: '本次完成率',
    can_not_report_un_finish_return_to_finish: '全部加工完成，請報完工！',
    has_package_process_single_report: '存在打包的工序，是否拆包報工？',
    pack_process_list: '打包工序清單',
    pack_single_report: '拆包報工',
    part_technical_file: '零件科技檔案',
    process_technical_file: '工序科技檔案',
    max_hour: '最小不能小於1分鐘，最大不能超過24小時',
    report_deplane: '完工',
    report_operate_a_computer: '開始',
    start_num: '開始數量',
    error_num: '不良數量',
    problem_classification: '問題分類',
    problem_description: '問題說明',
    please_input_start_num: '請輸入開始數量',
    report_material_code: '物料條碼',
    mat_code_can_not_repeat: '條碼不能重複',
    mat_code_not_null: '條碼不能為空',
    process_finish: '條碼不能為空工序當前報工記錄已經加工完成，請執行完工操作',
    batch_number: '報工批次號',
    file_size_error: '文件大小不能超過5M',
    finish_num_max_error: '最大完工數量不能大於報工數量',
    error_not_set_mrp:'請先設定工序的MR',
    time_interval:'時間區間',
    anomaly_classification:'异常分類',
    abnormal_quality:'質量异常',
    abnormal_production_line:'產線异常',
    abnormal_plan:'計畫异常',
    mould_status:'模具狀態',
    finish_tips:'提示：如任務未完工，請輸入已完成數量，否則默認為完工'
  },
  class_table_setting: {
    Employee_class_table: '員工班錶',
    Equipment_class_table: '設備班錶',
    Holiday_setting: '假日設定',
    Factory_holiday: '工廠假日',
    Employee_holiday: '員工假日',
    set_month: '设定月份',
    class_table: '班錶',
    detail: '明細',
    start_time: '開始時間',
    end_time: '結束時間',
    to_be_on_duty: '值日',
    rest: '休息',
    interrupt: '中斷',
  },
  progress: {
    show_finished_parts: '完工零件',
    show_plan_time: '計畫時間',
    show_actual_time: '實際時間',
    show_standard_st: '標準工時',
    show_actual_st: '實績工時',
    show_craft_name: '工藝名稱',
    show_finish_day: '完工天數',
    out_of_parts: '零件外發',
    combined_processing: '組合加工',
    process_synchronization: '工序同步',
    composite_relations_View: '組合關係',
    parts_filter: '零件篩選',
    add_sync: '添加同步',
    sync_record: '同步記錄',
    start_date: '起始日期',
    end_date: '結束日期',
    outgoing_process: '外發工序',
    outgoing_num: '外發數量',
    outgoing_date: '外發日期',
    pre_parts: '前置零件',
    pre_process: '前置工序',
    rear_parts: '後置零件',
    postprocess: '後置工序',
    combination_type: '組合類型',
    process_combination: '工序組合',
    part_assembly: '零件組合',
    message_The_current_process_exists_please_do_not_add_it_again: '當前工序以存在，請不要重複添加！',
    message_Can_not_assemble_the_same_parts: '不能組合相同的零件！',
    message_The_number_of_adding_processes_on_this_side_has_reached_the_maximum: '本側添加工序數量已達到最大值！',
    message_The_current_process_has_been_the_process_of_external_collaboration: '當前工序已經是外協工藝！',
    message_The_current_process_processing_status_does_not_allow_outsourcing: '當前工序加工狀態不允許外發！',
    message_The_process_code_of_synchronous_process_must_be_the_same: '同步工序的工藝編碼必須相同！',
    pack_type: '打包類型',
    pack_type_same_order: '同工單打包',
    pack_type_more_order: '跨工單打包'
  },
  holiday_setting: {
    factory_holiday_setting: '廠區假日設定',
    monday: '一',
    tuesday: '二',
    wednesday: '三',
    thursday: '四',
    friday: '五',
    saturday: '六',
    sunday: '日',
    factory_holiday: '工廠假日',
    user_overtime: '員工加班',
    user_holiday: '員工假日',
    user_holiday_tip: '如果設定日期為工廠假日，則狀態為員工加班.'
  },
  offline_file_setting: {
    file_describe: '檔案描述',
    storage_type: '存儲類型',
    file_format: '檔案格式',
    classify_name: '分類名稱',
    respective_region: '所屬區域',
    storage_type_local: '本地檔案',
    storage_type_ftp: 'ftp檔案',
    storage_type_sftp: 'sftp檔案',
    respective_region_project: '項目檔案',
    respective_region_order: '工單檔案',
    respective_region_part: '零件檔案',
    respective_region_process: '工序檔案',
    start_path: '起始路徑',
    server_host: '服務器IP',
    server_port: '服務器埠',
    server_user_name: '用戶帳戶',
    server_user_password: '登入密碼',
    label_width: '100px',
    file_path: '檔案路徑',
    add_fuzzy_path: '添加模糊路徑',
    add_fuzzy_path_confirm: '添加模糊路徑後，不支持文件上傳，需要手動操作，確定繼續嗎？',
    error_add_path: '請設定路徑',
    file_classify: "檔案分類",
    classify_setting: '檔案分類設定',
  },
  standard_procedure_setting: {
    title: '標題',
    width: '寬度',
    table: '表格',
    table_setting: '表格設定',
    production_params: '生產參數',
    add_plan_row: '添加計畫參數',
    add_real_row: '添加實際參數',
    device_operating_params: '設備運行參數',
    show_line_number: '顯示行號',
    show_row_number: '顯示行數',
    comparison_table: '比對表格',
    comparison_table_setting: '比對表格設定',
    comparison_mode: '比對管道',
    comparison_mode_1: '橫向比對',
    comparison_mode_2: '縱向比對',
    reference_column: '參照列名稱',
    each_generation_reference_column: '每次比對生成參照列',
    comparison_column_number: '比對列數量',
    comparison_column: '比對列名稱',
    form: '表單',
    form_setting: '表單設定',
    add_row: '添加行',
    delete_row: '删除行',
    add_column: '添加列',
    column_type: '列類型',
    column_number: '列數',
    column_format: '列格式',
    column_name: '列名稱',
    row_span: '跨越行數',
    column_span: '跨越列數',
    show_text: '顯示文字',
    input_box: '輸入框',
    data_type: '資料類型',
    double_reserved_points_prepend: '保留',
    double_reserved_points_append: '比特小數點',
    year: '年',
    month: '月',
    day: '日',
    hour: '時',
    minute: '分',
    second: '秒',
    show_code: '顯示編碼',
    show_name: '顯示名稱',
    show_code_and_name: '顯示編碼和名稱',
    current_row_can_not_add_column: '當前行不能添加列！',
    filed_column: '列欄位',
  },
  produce_plan: {
    plan_versions: '計畫版本',
    import_title: '導入',
    download_title: '匯出',
    upload_title: '導入計畫',
    chooseFile: '選擇檔案',
    uploadTip: '只能上傳xlsx/xls檔案，且不超過50M!',
    plan_of_day_title: '班組日計畫',
    appoint_day_plan: "設定日計畫",
    cancel_day_plan: "取消日计划",
    produce_day_plan: "日計畫",
    non_existent: "不存在！",
    load_st: "負荷工時",
    modal_cloud_setting: "模雲設定",
    middle_schedule: '中日程',
    part_middle_schedule: '零件中日程',
    small_schedule: '小日程',
    waiting_area: '待接收区',
    processing_area: '待加工区',
    completion_area: '完工区',
    employee_performance: '员工绩效',
    produce_plan_load: '生产负荷',
    stagnation_time: '遅い時間',
    receive_time: '接收时间',
    start_time: '开始时间',
    end_time: '结束时间'
  },
  produce_plan_load: {
    produce_plan_load_st: '負荷工時:',
    capacity_tip: '標準產能',
    max_capacity_tip: '最大產能',
  },
  quality_manage: {
    execute_state: '處理狀態',
    operation: '操作',
    po_num: 'PO號',
    delivery_note_num: '送貨單號',
    remedy_user: '補救人',
    duty_process: '責任工序',
    find_process: '發現工序',
    remedy_time: '補救日期',
    wait_for_initiation: '等待發起',
    remedies_will_signed: '補救措施會簽中',
    remedial_measures_were_not_signed: '補救措施會簽未通過',
    quality_tracing: '質量追溯',
    quality_traceability_signature_ing: '質量追溯會簽中',
    finished_process: '處理完畢',
    cancelled: '已取消',
    jointly_sign: '會簽',
    remedial_measures: '補救措施',
    person_liable: '責任人',
    find_people: '發現人',
    quantity_of_rework: '返工數量',
    error_classification: '錯誤分類',
    error_reason: '錯誤原因',
    specific_quantity: '特采數量',
    scrap_quantity: '報廢數量',
    common_signer_settings: '常用會簽人設定',
    initiating_countersign: '發起會簽',
    unsigned_execution: '無會簽執行',
    counter_signer: '會簽人',
    countersignature_status: '會簽狀態',
    countersigned_endorsement: '會簽批註',
    countersignature_time: '會簽時間',
    abandonment: '報廢下發',
    staff_coding: '員工編碼',
    employee_name: '員工名稱',
    remedies_will_be_signed: '補救措施會簽',
    quality_traceability_signature: '質量追溯會簽',
    selection_of_signers: '選擇會簽人',
    to: '於',
    cancel_countersign: '取消會簽',
    adopt: '通過',
    not_pass: '未通過',
    no_countersigned: '未會簽',
    label_width: '70px',
    loss_label_width: '80px',
    label_value_margin: '0px',
    please_select_responsible_process: '請選擇責任工序',
    please_select_the_person_responsible: '請選擇責任人',
    please_select_the_discovery_process: '請選擇發現工序',
    please_select_the_discoverer: '請選擇發現人',
    please_enter_the_quantity_of_rework: '請輸入返工數量',
    please_select_the_error_classification: '請選擇錯誤分類',
    please_enter_the_special_quantity: '請輸入特采數量',
    please_enter_the_amount_of_scrapped: '請輸入報廢數量',
    please_choose_the_way_to_deal_with_it: '請選擇處理管道',
    please_select_the_data_that_needs_to_be_signed: '請選中需要執行會簽的數據',
    successful_operation: '操作成功',
    penalty_charge: '處罰收費',
    amount_of_penalty: '處罰金額',
    loss_of_working_hours: '損失工時(H)',
    loss_due_date: '損失交期',
    loss_of_material_cost: '損失材料成本',
    loss_of_manufacturing_costs: '損失製造成本',
    penalty_notes: '處罰說明',
    will_sign_back_history: '會簽退回歷史',
    responsibility_judgement: '責任判定',
    punished_person: '被處罰人',
    please_choose_the_person_to_be_punished: '請選擇被處罰人',
    quality_traceability_will_sign_back_records: '質量追溯會簽退回記錄',
    will_sign_the_withdrawal_record: '會簽撤回記錄',
    operator_coding: '操作人員編碼',
    operator_name: '操作人員名稱',
    operation_time: '操作時間',
    details_of_withdrawal_records: '會簽撤回記錄明細',
    coding_of_responsible_person: '責任人編碼',
    name_of_responsible_person: '責任人名稱',
    responsible_human_type: '責任人類型',
    responsibility_ratio: '責任占比',
    supplier: '供應商',
    factory_staff: '本廠員工',
    supplier_staff: '供應商員工',
    general_factory_staff: '總廠員工',
    adding_responsible_persons: '添加責任人',
    yes: '是',
    no: '否',
    the_selected_signer_is_not_identical_with_the_actual_signer: '選中的會簽人與實際會簽人不一致，無法進行會簽!',
    display_completed_items: '顯示已完成項',
    delete_successfully: '删除成功！',
    canceled_deletion: '已取消删除',
    this_action_will_delete_the_selected: '此操作將删除選中的',
    an_exception_list_do_you_want_to_continue: '個异常單，是否繼續？?',
    only_canceled_data_can_be_deleted_the_current_selected_item_contains_other_states: '只能删除已取消狀態的數據，當前選中項中含有其他狀態！',
    rework: '返工',
    degrade: '特采',
    scrap: '報廢',
    you_signed_up_and_can_participate_again: "你已會簽完畢，不能再次參與",
    personnel: "人員",
    number: "數量",
    actual_technology_parameter: "工藝參數",
    indirect_material_cost: "間接材料成本",
    problem_classification: '問題分類',
    problem_description: '問題描述'
  },
  project_master_plan: {
    node_setting: '計畫節點設定',
    node_code: '節點編碼',
    node_name: '節點名稱',
    node_type: '節點類型',
    production_node: '生產節點',
    purchase_node: '採購節點',
    ability: '能力H/D',
    max_ability: '最大能力H/D',
    node_cost_type: '計畫節點-費用類型',
    cost_type_part_classify: '費用類型-零件分類',
    by_month: '按月',
    by_week: '按周',
    by_day: '按日',
    by_hours: '按小時',
    plan: '計畫',
    estimated_st: '預估工時',
    related_node: '關聯節點',
    relation_type: '關聯類型',
    postposition_days: '後置天數',
    plan_time: '計畫日期',
    plan_start_time: '計畫開始日期',
    plan_end_time: '計畫完成日期',
    actual_st: '實際工時',
    capacity_ratio: '產能比例',
    delivery_date: '交貨日期',
    delivery_date_change_count: '變更次數',
    delay_days: '延遲天數',
    unit_price: '單價',
    force_time: '強制時間區間',
    yes: '是',
    no: '否',
    plan_node_select: '選擇計畫節點',
    relation_plan_start_time: '關聯計畫開始日',
    relation_plan_end_time: '關聯計畫完成日',
    move_down: '下移',
    move_up: '上移',
    when_change_node_code: '正在修改節點編碼，將會導致重新計算節點加工進度，此操作比較耗時，確定要執行操作嗎？',
    master_plan_number: '主計畫節點數量',
    import_other_plan_node: '導入其他生產工單主計畫',
    node_is_used_can_not_change_type: '節點使用中，不能修改節點類型!'
  },
  project_master_plan_template_setting: {
    master_plan_template: '主計畫範本',
    template: '範本',
    template_name: '範本名稱',
    plan_node_list: '計畫節點清單',
    import: '導入',
    import_template: '導入範本',
    message_please_select_template_to_import: '請選擇要導入的範本',
    confirm_import_template: '確定要導入範本[%1]中的計畫節點嗎？',
  },
  cas_login: {
    cas_login_message_authentication_failure: '認證失敗!',
    cas_login_message_employee_not_found: '認證失敗，沒有找到對應用戶!',
    cas_login_message_factory_not_found: '認證失敗，沒有找到對應廠區!'
  },
  age: {
    add_project: '新建項目',
    modify_project: '編輯項目',
    add_sub_project: '新建子項目',
    save_and_add_subprojects: '保存並添加子項目',
    save_and_add_peer_projects: '保存並添加同級項目',
    edit_project: '編輯',
    delete_project: '删除',
    project_plan: '項目計畫',
    add_produce_order: '新增生產工單',
    add_project_order: '新增项目工單',
    parent_project_code: '上級項目編碼',
    project_classify: '項目類型',
    project_code: '項目編碼',
    project_name: '項目名稱',
    project_order_code: '项目工单',
    custom: '客戶',
    custom_code: '客戶編碼',
    custom_name: '客戶名稱',
    end_custom: '終端客戶',
    end_custom_code: '終端客戶编码',
    end_custom_area: '終端客戶區域',
    project_leader: '負責人',
    input_time: '錄入時間',
    delivery_time: '項目交期',
    project_ratio: '進度',
    project_amount: '項目金額',
    budget_amount: '預算金額',
    receivable_amount: '應收金額',
    unpaid_amount: '可收金額',
    paid_amount: '已付金額',
    budget_manage: '預算管理'
  },
  download: {
    offLineTools: {
      title: 'MES線下輔助工具',
      describe: '用於導入排程數據以及在文件管理中，上傳、打開線下檔案（支持ftp、sftp、本地檔案）。如果使用到了自動排程或文件管理模塊，必須下載該軟件配合使用。軟件為託盤程式，啟動後自動運行在系統託盤中。支持Windows7、windows8、windows10。',
      language: '語言',
      file_name: '檔案名稱',
      size: '大小',
      download: '下載'
    }
  },
  forms: {
    monitoring_platform: '監控平臺',
    details_of_staff_daily: '員工日報明細',
    process_in_machining: '加工中工序',
    department: '部門',
    export_config: '匯出設定',
    export_column_selector: '選擇匯出列',
    process_status: '工序狀態',
    mach_status: '加工狀態',
    performance_total_amount: '實績金額',
    standard_total_amount: '標準金額',
    performance_summary: '實績匯總報表',
    actual_amount: '實績金額',
    standard_amount: '標準金額',
    abnormal_working_hours: '异常工時',
    abnormal_cost: '异常成本',
    unplanned_hours: '計畫外工時',
    unplanned_amount: '計畫外金額',
    rate_of_progress: '進度率',
    report_quality_department: "質量報表",
    workshop_report: '車間報表',
    quality_report: "質量報表",
    processing_mode: "處理管道",
    quality_state: "質量狀態",
    number_errors: "錯誤件數",
    discovery_time: "發現時間",
    component_type: "零件類型",
    parts_and_processes: "零件&工序",
    discard_time: "報廢工時",
    rework_time: "返工工時",
    standard_preparation_time: "標準準備工時",
    standard_manpower_hours: "標準人力工時",
    standard_device_hours: "標準設備工時",
    performance_preparation_time: "實績準備工時",
    performance_manpower_hours: "實績人力工時",
    performance_device_hours: "實績設備工時",
    outside_and_purchase_process: '外協和採購',
    details_of_cost_report: '實際明細報表',
    indirect_code: '間接編號',
    indirect_date: '間接時間',
    outside_the_plan: '計畫外',
    inside_the_plan: '計畫內',
    cost_report: '成本報表',
    submit_cost_details: '成本科目報表',
    plan_amount: '計畫金額',
    abnormal_amount: '异常金額',
    cost_type_manage_children: '子費用類型',
    planned_cost: '計畫成本',
    actual_cost: '實際成本',
    total_planned_hours: '計畫總工時',
    total_actual_hours: '實際總工時',
    total_abnormal_hours: '异常總工時',
    total_unplanned_hours: '計畫總工時',
    total_unplanned_cost: '計畫外成本',
    processing_cost: '加工成本',
    outside_process_cost: '外協成本',
    procurement_cost: '採購成本',
    quality_analysis_report: "品質分析報表",
    error_type: "錯誤類型",
    wrong_number: "錯誤數量",
    responsible_team: "責任班組",
    responsible_supplier: "責任供應商",
    statistical_histogram: "統計柱狀圖",
    quality_management_report: "品質管制報表",
    part_and_process_schedule: '零件工序進度報表',
    details_of_device_daily: '設備日報明細',
    alert_of_staff_abnormal: '員工報工异常預警',
    processing_timeout: '加工超時',
    part_warehouse_status_analysis:'零件进度情况表',
    finish_num:'完工数量',
    inventory_num:'入库数量',
    not_inventory_num:'未入库数量',
    inventory_type:'入库类型',
    part_put_in_storage:'零件入库',
    order_put_in_storage:'订单入库',
    total_weight:'总重',
    employee_salary_detail: '员工工资明细',
    valuation_weight:"计价单量",
    valuation_weight_total:"计价总量",
    process_money:"工序总价",
    valuation_method:"计价方式",
    fixed_salary:"固定工资",
    overtime_money:"加班工资",
    overtime_hours:"加班时长",
    total_wages:"总工资",
    share_cost_details:"分攤成本報表",
  },
  recovery: {
    title: '删除資料恢復',
    recovery: '恢復',
    delete_user: '删除人',
    delete_time: '删除時間',
    recovery_order: '確定要恢復選中的【%1】條數據？',
    recovery_mach: '確定要恢復選中的【%1】條報工記錄？恢復後，需要手動調整對應報工的數量、工時'
  },
  customer_form: {}
};



// WEBPACK FOOTER //
// ./src/common/lang/tw.js